import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationForUser } from '../../../models/borrower-portal/application-for-user-model';
import { ApplicationTaskModel } from '../../../models/borrower-portal/application-task-model';

@Component({
    selector: 'tasks-online-app',
    templateUrl: './tasks-online-app.component.html',
    styleUrls: ['./tasks-online-app.component.scss'],
    standalone: false
})
export class TasksOnlineAppComponent implements OnInit {

  @Input() tasks: ApplicationTaskModel[] = [];
  @Input() application: ApplicationForUser;
  @Input() isAgent: boolean = false;
  @Input() isSubmitted: boolean;

  /** Tracks which task cards are expanded on mobile */
  protected expandedTaskIds = new Set<number>();

  constructor(private readonly _router: Router) { }

  ngOnInit(): void {
  }

  toggleTaskExpanded(taskId: number): void {
    if (this.expandedTaskIds.has(taskId)) {
      this.expandedTaskIds.delete(taskId);
    } else {
      this.expandedTaskIds.add(taskId);
    }
  }

  isTaskExpanded(taskId: number): boolean {
    return this.expandedTaskIds.has(taskId);
  }

  goToCompleteApplication = () => {
    const routeToGo = this.application.onlineApplicationIsCoborrower ? 'co-apply' : 'apply';
    this._router.navigate(
      [routeToGo],
      {
        queryParams: {
          companyGuid: this.application.companyGuid,
          appId: this.application.applicationId,
          flowGuid: this.application.onlineApplicationVersion,
        },
        queryParamsHandling: 'merge'
      });
  }
}
